import React from 'react'
import { Bar } from 'react-chartjs-2'

class Graph extends React.Component {
  constructor() {
    super();
    this.state = {
      chartData: null,
    }
  }

  render() {
    console.log(this.props.strataData);
    var theData = [];

    for (var i = 0; i < this.props.strataData.length; i++) {
      if (this.props.strataData[i].strata || this.props.strataData[i].to || this.props.strataData[i].from) {
        var stname = this.props.strataData[i].strata;
        var depth = [0];
        if (this.props.strataData[i].to - this.props.strataData[i].from > 0) {
          depth = [(this.props.strataData[i].to - this.props.strataData[i].from)];
        }
        var color = '#F9F0DE';

        if (stname.includes("sand") || stname.includes("Sand")) { color = "#FFD684"; }
        if (stname.includes("clay") || stname.includes("Clay")) { color = "#734222"; }
        if (stname.includes("coal") || stname.includes("Coal")) { color = "#3D3A36"; }
        if (stname.includes("basalt") || stname.includes("Basalt")) { color = "#B2B2B2"; }
        if (stname.includes("dirt") || stname.includes("Dirt") || stname.includes("soil") || stname.includes("Soil")) { color = "#917932"; }

        theData.push({
          label: stname,
          data: depth,
          borderWidth: 1,
          borderColor: 'white',
          backgroundColor: color
        });
      }

    }
    return (
      <div style={{ height: '800px', width: '300px', margin: 'auto' }}>
        <Bar
          data={{
            labels: ["Strata"],
            datasets: theData
          }}
          options={{
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  reverse: true
                },
                stacked: true
              }]
            },
            title: {
              display: false
            },
            legend: {
              display: false
            },
            hover: {
              mode: 'nearest',
              intersect: true
            },
            responsive: true,
            maintainAspectRatio: false
          }}
          key={Math.random()}
        />
      </div>

    )
  }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/components/Bores/Graph.js
